import { Chip } from "@mui/material";
import type { FC } from "react";
import type { OrderStatus } from "../../data/BaseEntity";
import { StatusColors } from "./StatusColors";
import { orderStatusToName } from "./orderStatusToName";

interface Props {
  value: OrderStatus;
  size: "small" | "medium";
}

const OrderStatusView: FC<Props> = ({ value, size }) => (
  <Chip
    label={orderStatusToName(value)}
    size={size}
    sx={{
      fontWeight: 500,
      opacity: 0.9,
      bgcolor: StatusColors[value],
      color: "#fff",
    }}
  />
);

export default OrderStatusView;
